module.exports = __webpack_public_path__ + "img/Component_production_stock.eab63cd2.svg";